import React from "react";
import flowers from "../assets/flowers.png";
import "./preloader.css";

const Preloader = ({ progress }) => {
  return (
    <main
      aria-label="Loading the website"
      aria-live="polite"
      className="site_preloader"
      role="status"
    >
      <div className="site_preloader_glow" aria-hidden="true" />
      <img src={flowers} className="site_preloader_flowers" alt="" />

      <section className="site_preloader_panel">
        <p className="site_preloader_eyebrow">Loading The Archive</p>
        <h1 className="site_preloader_title">Emily Dickinson</h1>
        <p className="site_preloader_text">
          Gathering the room, the portraits, and the fragments.
        </p>

        <div className="site_preloader_track" aria-hidden="true">
          <div
            className="site_preloader_fill"
            style={{ width: `${progress}%` }}
          />
        </div>

        <p className="site_preloader_value">{progress}%</p>
      </section>
    </main>
  );
};

export default Preloader;
